import * as CubeTree from '../cubeTree/index';
import * as Toolkit from '../toolkit/index';
import * as UIToolkit from '../UIToolkit/index';
import FrontCubeData from '../frontCubeData/index';
import Config from '../config';
import { updateCubeList } from './updateCubeList';

function updateLayerWithoutLayout(layers: CubeId[]): void {
    layers.forEach((layer: CubeId): void => {
        let stageWindow: StageWindow = window;

        // TODO: 容错，打孔需求
        let parentId: CubeId = CubeTree.findParentIdByCubeId(layer);
        let parentCube: CubeNode = CubeTree.findByCubeId(parentId);
        let cube: CubeNode = CubeTree.findByCubeId(layer);

        stageWindow.FILTER_OF_STAGECORE.mainAlgorithm(cube, parentCube, (res: FreeObjMap): void => {
            // mainAlgorithm会对数据做更改后，所以在这里需要强制更新一次前端数据
            updateLayerAndChildFrontData(cube.id);

            // 触发一次层板更新
            cube.update({
                notLayout: true
            });

            let childCubeIds: CubeId[] = CubeTree.getChildCubeIds(cube.id);

            // 触发层板子级更新
            updateCubeList(childCubeIds);
        });
    });
}

function updateLayerHasLayout(layers: CubeId[]): void {
    layers.forEach((layer: CubeId): void => {
        let stageWindow: StageWindow = window;

        // TODO: 容错，打孔需求
        let parentId: CubeId = CubeTree.findParentIdByCubeId(layer);
        let parentCube: CubeNode = CubeTree.findByCubeId(parentId);
        let cube: CubeNode = CubeTree.findByCubeId(layer);

        stageWindow.FILTER_OF_STAGECORE.mainAlgorithm(cube, parentCube, (res: FreeObjMap): void => {
            // mainAlgorithm会对数据做更改后，所以在这里需要强制更新一次前端数据
            updateLayerAndChildFrontData(cube.id);

            // 触发一次层板更新
            cube.update({
                notLayout: false
            });

            let childCubeIds: CubeId[] = CubeTree.getChildCubeIds(cube.id);

            // 触发层板子级更新
            updateCubeList(childCubeIds);
        });
    });
}

function updateLayersLayout(): void {
    let layers: CubeId[] = CubeTree.findLayersCanDrop();

    layers.forEach((layer: CubeId): void => {
        let cube: CubeNode = CubeTree.findByCubeId(layer);

        UIToolkit.updateGoodsLayout(cube);
    });
}

function layerForceLayout(): void {
    let autoUpShelves: boolean = Config.getGlobalConfig('autoUpShelves');
    let autoUpAndDownShelves: boolean = Config.getGlobalConfig('autoUpAndDownShelves');

    if (!autoUpShelves && !autoUpAndDownShelves) {
        return;
    }

    Config.setGlobalConfig('autoUpShelves', false);
    Config.setGlobalConfig('autoUpAndDownShelves', false);
    updateLayersLayout();
    Toolkit.log({
        action: '更新',
        msgList: [
            {
                name: '自动上图，强制更新层板布局:',
                value: '--'
            }
        ]
    });
}

function updateLayerAndChildFrontData(cubeId: CubeId): void {
    // 更新层板的前端字段
    FrontCubeData.updateAllKeysByCubeId(cubeId);

    // 并且要更新此层板下的商品前端字段
    let childCubeIds: Array<CubeId> = CubeTree.getChildCubeIds(cubeId);

    childCubeIds.forEach((cubeId: CubeId): void => {
        FrontCubeData.updateAllKeysByCubeId(cubeId);
    });
}

export {
    updateLayerWithoutLayout,
    updateLayerHasLayout,
    layerForceLayout
};
